import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useEffect, useMemo, useState } from 'react';
import useSafeTimeout from './use-safe-timeout';
var appearDelay = 40;
function useTransitionState(opened, options) {
  var _useState = useState('init'),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useMemo = useMemo(function () {
      return options || {};
    }, [options]),
    _useMemo$duration = _useMemo.duration,
    duration = _useMemo$duration === void 0 ? 0 : _useMemo$duration;
  var setSafeTimeout = useSafeTimeout();
  var close = useCallback(function () {
    if (!/appear|show/.test(state)) {
      return;
    }
    return new Promise(function (resolve) {
      setState('exit');
      setSafeTimeout(function () {
        setState('idle');
        resolve(true);
      }, duration);
    });
  }, [opened, state]);
  useEffect(function () {
    if (opened && /init|idle/.test(state)) {
      setState('appear');
      setSafeTimeout(function () {
        return setState('show');
      }, appearDelay);
    }
    if (!opened) {
      close();
    }
  }, [opened]);
  return [state, close];
}
export default useTransitionState;